define('app/directives/left_menu',['require', 'angular', 'app/services/shared', 'json!mdactions.json'], function (require, angular, shared, resources) {
  var module = angular.module('app.left_menu', ['app.shared'])
  //var resources = require('json!mdactions.json');

  // Menu lateral
  module.directive('ocLeftMenu', ['$compile', 'sharedProperties', '$location', '$mdDialog', 'hotkeys', 'globalService', function ($compile, sharedProperties, $location, $mdDialog, hotkeys, globalService) {
    return {
      restrict: 'E',
      templateUrl: 'templates/directives/left_menu.html',
      scope: {},
      link: {
        pre: function preLink (scope, iElement, iAttrs, controller) {

          if (resources.global) {
            angular.forEach(resources.global.actions, function (action, action_name) {
              hotkeys.bindTo(scope).add({combo: action.hotkey, description: action.name, callback: function () {
                  globalService.consumeAction(action);
                }
              });
            });
          }

          scope.openPath = function (url, evt) {
            var loc = url;
            if (evt && evt.ctrlKey == true) {
              if ($location.$$path === '/') {
                loc = $location.$$absUrl.replace('#/', '#' + url);
              }
              else {
                loc = $location.$$absUrl.replace($location.$$path, url);
              }
              $window.open(loc, '_blank'); // in new tab
            } else {
              $location.url(loc)
            }
          }

          var rootMenu = [];
          angular.forEach(resources.menu.actions, function (action, action_name) {
            if (!action.parent)
              this.push(action);
            if (action.hotkey) {
              hotkeys.bindTo(scope).add({combo: action.hotkey, description: action.name, callback: function () {
                $location.url(action.actions[0].url);//globalService.consumeAction(action);
              }});
            }
          }, rootMenu);

          scope.menu = [];
          angular.forEach(rootMenu, function (action, action_name) {
            action.childs = [];
            scope.menu.push(action);

            angular.forEach(resources.menu.actions, function (subaction) {
              if (subaction.parent && subaction.parent == action.id)
                action.childs.push(subaction);
            });

          });
        }
      }
    }
  }])
  return module
})
;
